import { render, staticRenderFns } from "./tab-form.vue?vue&type=template&id=f5574d52&scoped=true&"
import script from "./tab-form.vue?vue&type=script&lang=js&"
export * from "./tab-form.vue?vue&type=script&lang=js&"
import style0 from "./tab-form.vue?vue&type=style&index=0&id=f5574d52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5574d52",
  null
  
)

export default component.exports